export interface QueryBuilder {
    toQueryMap: () => Map<string, string>;
    toQueryString: () => string;
  }
      
  export class QueryOptions implements QueryBuilder {
    public pageNumber: number;
    public pageSize: number;
    public queryMap :Map<string, string>;
    public roleFilter :any;
    public sortField: String;
    public sortOrder: String;
    public category: any;
    public technology: any;
    public recruiter: any;
    public status: any;
    public dateRange:any;
    public dateString :any;
    public applicantsFilter:any;
    public interviewStatusFilter:any;
    public technologyFilter:any;
    public recruiterFilter:any;
    public interviewStepFilter:any;
    public candidateStatusFilter:any;
    public jdFilter:any;
    constructor(qParams: object) {
      if(qParams['sortParam']){
        this.sortField = qParams['sortParam']['sortField'];
        this.sortOrder = qParams['sortParam']['sortOrder'] == 1 ? "ASC" : "DESC";
      }
      if(qParams['pageParam']){
        this.pageNumber = qParams['pageParam']['page'];
        this.pageSize = qParams['pageParam']['size'];
      }
      if(qParams['filterParam']){
        this.category = qParams['filterParam']['category'];
        this.technology = qParams['filterParam']['technology'];
        this.recruiter = qParams['filterParam']['recruiter'];
        this.status = qParams['filterParam']['status'];
        this.dateRange = qParams['filterParam']['dateRange']
      }
      if(qParams['viewScheduleFilter']){
        this.applicantsFilter=qParams['viewScheduleFilter']['candidate'];
        this.interviewStatusFilter=qParams['viewScheduleFilter']['interviewStatus'];
      }
      if(qParams['viewInterviewFilter']){
        this.roleFilter=qParams['viewInterviewFilter']['role'];
        this.technologyFilter=qParams['viewInterviewFilter']['technology'];
        this.recruiterFilter=qParams['viewInterviewFilter']['recruiters'];
        this.interviewStepFilter=qParams['viewInterviewFilter']['interviewType'];
        this.dateString=qParams['viewInterviewFilter']['date'];
        this.applicantsFilter=qParams['viewInterviewFilter']['candidate'];
        this.candidateStatusFilter = qParams['viewInterviewFilter']['candidateStatus'];
      }

      if(qParams['viewInterviewerFilter']){
        this.jdFilter=qParams['viewInterviewerFilter']['jdName'];
        this.recruiterFilter=qParams['viewInterviewerFilter']['recruiters'];
        this.interviewStepFilter=qParams['viewInterviewerFilter']['interviewType'];
        this.dateString=qParams['viewInterviewerFilter']['date'];
      }
      //this.pageNumber = 1;
      //this.pageSize = 50;
      this.queryMap= new Map<string,string>();
    }
    toQueryMap() {
     // const queryMap = new Map<string, string>();
     if(this.pageNumber!=undefined)
     this.queryMap.set('page', `${this.pageNumber}`);
     if(this.pageSize!=undefined)
     this.queryMap.set('size', `${this.pageSize}`);
     if(this.sortField!=undefined)
     this.queryMap.set('sort', `${this.sortField}` + "," + `${this.sortOrder}`)
     if(this.category || this.technology || this.recruiter || this.status || this.dateRange){
     this.queryMap.set('filters','category:'+ `${this.category ? this.category.toString() : null}` +
      ';technology:'+ `${this.technology ? this.technology.toString():null}` + 
      ';recruiter:'+ `${this.recruiter ? this.recruiter.toString():null}` + 
      ';status:'+ `${this.status ? this.status.toString() : null}` +
       ';dateRange:'+ `${this.dateRange ? this.dateRange.toString() : null}`)
     }
     if(this.applicantsFilter && this.applicantsFilter.length>0){
       this.queryMap.set('applicant', `${this.applicantsFilter.toString()}`);
     }
      if(this.interviewStatusFilter && this.interviewStatusFilter.length>0){
       this.queryMap.set('status', `${this.interviewStatusFilter.toString()}`);
     }
     if(this.roleFilter && this.roleFilter.length>0){
       this.queryMap.set('role',`${this.roleFilter.toString()}`)
     }
     if(this.technologyFilter && this.technologyFilter.length>0){
      this.queryMap.set('technology',`${this.technologyFilter.toString()}`)
     }
     if(this.recruiterFilter && this.recruiterFilter.length>0){
      this.queryMap.set('recruiters',`${this.recruiterFilter.toString()}`)
     }
     if(this.interviewStepFilter && this.interviewStepFilter.length>0){
      this.queryMap.set('interviewType',`${this.interviewStepFilter.toString()}`)
     }
     if(this.dateString){
      this.queryMap.set('dateRange',`${this.dateString.toString()}`)
     }
     if(this.jdFilter && this.jdFilter.length>0){
      this.queryMap.set('jd',`${this.jdFilter.toString()}`)
     }
     if(this.candidateStatusFilter && this.candidateStatusFilter.length>0){
      this.queryMap.set('candidateStatus',`${this.candidateStatusFilter.toString()}`)
     }
      this.queryMap=this.queryMap;
      return this.queryMap;
    }
  
    toQueryString() {
      let queryString = '';
      this.queryMap.forEach((value: string, key: string) => {
        queryString = queryString.concat(`${key}=${value}&`);
      });
  
      return queryString.substring(0, queryString.length - 1);
    }
  }